import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const FaqViewAuditorModule = lazy(loadModule);

export default FaqViewAuditorModule;
